'use strict';

var ConfigurationParameterModalDirective = function ConfigurationParameterModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/configuration-parameter-modal.html'),
    controller: 'ConfigurationParameterModalController',
    scope: {
      type: '=',
      typeLabel: '=',
      level: '=',
      columns: '=',
      eventData: '=',
      isModalShown: '=',
      readOnly: '=',
      customRenderers: '=',
      subTypeLabel: '='
    },
    link: function link($scope, element) {
      $scope.hideModal = function () {
        $scope.showGrid = false;
        $scope.isModalShown = false;
        element.modal('hide');
      };
      $scope.showModal = function () {
        element.modal('show');
        $scope.showGrid = true;
      };
      $scope.isValidationMessage = function () {
        var validationMessageCssDisplay = element.find('.jqx-grid-validation').css('display');
        return validationMessageCssDisplay && validationMessageCssDisplay !== 'none';
      };
    }
  };
};
ConfigurationParameterModalDirective.$inject = [];
module.exports = ConfigurationParameterModalDirective;